import { createContext, useContext } from "react";

// Create a context
export const LvIdentifierContext = createContext("");

// Create a custom hook for easy access to lvIdentifier
export const useLvIdentifier = () => {
  return useContext(LvIdentifierContext);
};
